// The one priority criterion for what a scan finds, the same on every screen and report. It follows how
// much a problem hinders people (the impact the test reports), not legal risk, and says "pending review"
// whenever the automated test could not decide, instead of guessing.

export const PRIORITIES = ['alta', 'media', 'baja', 'pendiente'] as const;
export type Priority = (typeof PRIORITIES)[number];

/** Highest first; a review pending a decision comes after the confirmed problems. */
export const PRIORITY_RANK: Record<Priority, number> = { alta: 0, media: 1, baja: 2, pendiente: 3 };

export function priorityOf(issue: {
  result: 'violation' | 'incomplete';
  severity: 'critica' | 'grave' | 'moderada' | 'leve' | string;
}): Priority {
  if (issue.result === 'incomplete') return 'pendiente';
  switch (issue.severity) {
    // Critical and serious failures can stop someone from completing a task.
    case 'critica':
    case 'grave':
      return 'alta';
    case 'moderada':
      return 'media';
    case 'leve':
      return 'baja';
    // A severity we do not know is not guessed: somebody has to look at it.
    default:
      return 'pendiente';
  }
}

/** The more urgent of two priorities. */
export const mostUrgent = (a: Priority, b: Priority): Priority =>
  PRIORITY_RANK[a] <= PRIORITY_RANK[b] ? a : b;
